"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPickedShapes = void 0;
var create_selector_1 = require("../../../../state/create_selector");
var geometries_1 = require("./geometries");
function getCurrentPointerPosition(state) {
    return state.interactions.pointer.current.position;
}
exports.getPickedShapes = create_selector_1.createCustomCachedSelector([geometries_1.geometries, getCurrentPointerPosition], function (geoms, pointerPosition) {
    var picker = geoms.pickQuads;
    var x = pointerPosition.x, y = pointerPosition.y;
    return picker(x, y);
});
//# sourceMappingURL=picked_shapes.js.map